import api from './api';

export const getAccountingSettings = () => api.get('/accounting/settings');
export const updateAccountingSettings = (data) => api.put('/accounting/settings', data);
export const getAccountingReadiness = () => api.get('/accounting/readiness');
export const updateBusinessIdentity = (data) => api.put('/accounting/business-identity', data);
export const updateTestMode = (testMode, password) => api.put('/accounting/test-mode', { test_mode: testMode, password });
